import {
  byUserInteraction,
} from '@html/_common/utils';

import PhotoCarousel from './photo-carousel';

export default function initiateCustomerPhotos(eventCategory, imageGalleryLightboxManager) {
  const photoCarousel = new PhotoCarousel('.js-tour-photo-carousel', '.js-tour-photo-carousel__item');
  photoCarousel.initiate();

  byUserInteraction('customer-photos', () => {
    // initiate gallery
    const imageUrls = $.map($('.js-tour-photo-carousel__item img'), (el) => $(el).data('src'));
    const galleryTitle = $('.js-tour-photo-carousel__wrapper').data('gallery-title') || 'Customer Photos';

    if (!imageUrls.length) { return; }

    imageGalleryLightboxManager.createNewImageGallery(imageUrls, {
      openElementSelector: '.js-tour-photo-carousel__item, .js-ao-tour-customer-photos__see-all',
      startingIndex: (event) => parseInt($(event.currentTarget).data('image-index'), 10),
      lowerResolutionImageSize: '720',
      higherResolutionImageSize: '1440',
      galleryTitle,
      googleEvents: {
        category: eventCategory,
        eventGalleryName: 'Customer Photos',
        actionVariations: [
          {
            className: 'js-ao-tour-customer-photos__image-wrapper',
            action: 'With image click',
          },
          {
            className: 'js-ao-tour-customer-photos__see-all',
            action: 'With see all button',
          },
        ],
      },
    });
  });
}
